import moment from 'moment';

const getDateFormatted = (date) => {
  return moment(date).format('DD/MM/YYYY');
};

const getFinalAdddress = (adddressValue, type) => {
  let finalAdddress;

  if (adddressValue.lookupValue || adddressValue.enterManually == true || adddressValue.addressLine) {
    finalAdddress = {
      ...adddressValue,
      addressType: type,
      addressNotChanged: false,
      international: adddressValue.international
    };
  } else {
    finalAdddress = {
      addressNotChanged: true,
      addressType: type,
      international: false
    };
  }
  return finalAdddress;
};

const getExistingAddressLine = (addresses, addressType) => {
  // TODO: move to main helper file
  let finalAddress;

  const addr = addresses.find((a) => a.addressType === addressType);
  if (addr !== undefined) {
    finalAddress = `${addr.addressLine1}, ${addr.suburb}, ${addr.state}, ${addr.postcode}`;
  }

  return finalAddress;
};

const get2FAExistingAddressLine = (addresses, addressType) => {
  let finalAddress;

  const addr = addresses.find((a) => a.addressType === addressType);
  if (addr !== undefined) {
    finalAddress = `${addr.addressLine}, ${addr.suburb}, ${addr.state}, ${addr.postCode}`;
  }

  return finalAddress;
};

const getAddressLine = (address) => {
  if (address?.lookupValue) {
    return address?.lookupValue?.label;
  } else if (address?.international) {
    let tempInternationalAddress = '';
    if (address?.addressLine) {
      tempInternationalAddress += `${address?.addressLine} `;
    }
    if (address?.suburb) {
      tempInternationalAddress += `${address?.suburb} `;
    }
    if (address?.state) {
      tempInternationalAddress += `${address?.state} `;
    }
    if (address?.postcode) {
      tempInternationalAddress += `${address?.postcode} `;
    }
    if (address?.country) {
      tempInternationalAddress += `${address?.country}`;
    }

    return tempInternationalAddress;
  } else if (address?.enterManually) {
    let tempManualAddress = '';
    if (address?.addressLine) {
      tempManualAddress += `${address?.addressLine} `;
    }
    if (address?.suburb) {
      tempManualAddress += `${address?.suburb} `;
    }
    if (address?.state) {
      tempManualAddress += `${address?.state.text} `;
    }
    if (address?.postcode) {
      tempManualAddress += `${address?.postcode}`;
    }

    return tempManualAddress;
  } else if (address?.addressID) {
    let tempExistingAddress = '';
    if (address?.addressLine1) {
      tempExistingAddress += `${address?.addressLine1} `;
    }
    if (address?.suburb) {
      tempExistingAddress += `${address?.suburb} `;
    }
    if (address?.state) {
      tempExistingAddress += `${address?.state} `;
    }
    if (address?.postcode) {
      tempExistingAddress += `${address?.postcode}`;
    }

    return tempExistingAddress;
  } else if (address?.id) {
    let tempExistingInternationalAddress = '';
    if (address?.addressLine1) {
      tempExistingInternationalAddress += `${address?.addressLine1} `;
    }
    if (address?.suburb) {
      tempExistingInternationalAddress += `${address?.suburb} `;
    }
    if (address?.state) {
      tempExistingInternationalAddress += `${address?.state} `;
    }
    if (address?.postcode) {
      tempExistingInternationalAddress += `${address?.postcode}`;
    }

    return tempExistingInternationalAddress;
  }
};

export { getDateFormatted, getFinalAdddress, getExistingAddressLine, getAddressLine, get2FAExistingAddressLine };
